// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--RcRzG","durations":"dd31006766--durations--_XrC2"};